import { RadioGroup, styled } from '@ori-ui/mui';

export const Root = styled(RadioGroup)(({ theme }) => ({
  alignItems: 'stretch',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: '21px',
  margin: theme.spacing(0, 6, 3, 0),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    marginBottom: '18px',
  },
}));
